export class PagerService {
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
        // calculate total pages
        // tslint:disable-next-line:prefer-const
        let totalPages = Math.ceil(totalItems / pageSize);

        // ensure current page isn't out of range
        if (currentPage < 1) {
            currentPage = 1;
        } else if (currentPage > totalPages) {
            currentPage = totalPages;
        }

        // tslint:disable-next-line:one-variable-per-declaration
        let startPage: number, endPage: number;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        // tslint:disable-next-line:prefer-const
        let startIndex = (currentPage - 1) * pageSize;
        // tslint:disable-next-line:prefer-const
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        // tslint:disable-next-line:prefer-const
        let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        // return object with all pager properties required by the view
        return {
            // tslint:disable-next-line:object-literal-shorthand
            totalItems: totalItems,
            // tslint:disable-next-line:object-literal-shorthand
            currentPage: currentPage,
            // tslint:disable-next-line:object-literal-shorthand
            pageSize: pageSize,
            // tslint:disable-next-line:object-literal-shorthand
            totalPages: totalPages,
            // tslint:disable-next-line:object-literal-shorthand
            startPage: startPage,
            // tslint:disable-next-line:object-literal-shorthand
            endPage: endPage,
            // tslint:disable-next-line:object-literal-shorthand
            startIndex: startIndex,
            // tslint:disable-next-line:object-literal-shorthand
            endIndex: endIndex,
            // tslint:disable-next-line:object-literal-shorthand
            pages: pages
        };
    }
}
